import { Avatar, Collapse,Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import {
  GeAdHocNotification,
  GeMailLogs,
  GeNotificationIcon,
  GeReports,
  GeSettings,
  GeSettingsGeneral,
  GeTestsIcon,
  GeUsersIcon,
  GeLogIcon,
  GeDashboardIcon,
  GeEditIcon
} from "./General/GeneralIcons";
import React, { useEffect, useState } from "react";
import AssistantIcon from "@mui/icons-material/Assistant";
import WidgetIcon from "@mui/icons-material/Widgets";
import CommentIcon from "@mui/icons-material/Comment";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DatasetIcon from "@mui/icons-material/Dataset";
import AssessmentIcon from "@mui/icons-material/Assessment";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import { Link as RouterLink, useHistory } from "react-router-dom";
import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/material/styles";
import { userStore } from "../Services/store";
import SmartToyIcon from '@mui/icons-material/SmartToy';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import HelpIcon from '@mui/icons-material/Help';
import WarningIcon from '@mui/icons-material/Warning';

const useStyles = makeStyles((theme) => ({
  sidebarContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    padding: 0,
    margin: 0,
  },
  active: {
    borderLeftStyle: "solid",
    borderLeftWidth: "4px",
    borderLeftColor: theme.palette.secondary.main,
    paddingLeft: "12px"
  },
  activeMenu: {
    borderLeftStyle: "solid",
    borderLeftWidth: "2px",
    borderLeftColor: theme.palette.secondary.main,
    paddingLeft: "14px"
  },
  avatarIcon: {
    fontWeight: "bold",
    color: theme.palette.secondary.main,
    backgroundColor: "transparent",
    width: 24
  },
  nested: {
    paddingLeft: theme.spacing(3)
  },
  nestedActive: {
    paddingLeft: theme.spacing(3) - 4
  },
  listItemIcon: {
    minWidth: 40
  },
  routesContainer: {
    flexGrow: 1,
  },
  footerMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
    fontWeight: 'bold',
    fontSize: '0.9rem',
    borderTop: `2px solid ${theme.palette.warning.main}`,
    boxShadow: `0px -2px 4px rgba(0, 0, 0, 0.2)`,
    margin: 0 // Ensures no additional margin
  },
  warningIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.warning.dark,
  },
  routesContainer: {
    flexGrow: 1,
  },
}));

const RouteType = {
  Internal: "internal",
  External: "external",
  Action: "action",
  Menu: "menu"
};

const onHangfireUrl = () => {
  var a = document.createElement("a");
  a.target = "_blank";
  a.href = `${process.env.REACT_APP_BACKEND_URL}/hangfire?access_token=${userStore.token}`;
  a.click();
};

const onHelpUrl = () => {
  var a = document.createElement("a");
  a.target = "_blank";
  a.href = `https://sh3argos.sharepoint.com/sites/MosAIQEditorExtranet/SitePages/Overview.aspx`;
  a.click();
};

const HangFireIcon = withStyles((theme) => ({
  root: {
    fontWeight: "bold",
    color: theme.palette.secondary.main,
    backgroundColor: "transparent",
    width: 24
  }
}))(Avatar);

const adminRoutes = [
  {
    text: "Chat with AI",
    type: RouteType.Internal,
    to: "/chatbot",
    icon: <SmartToyIcon />
  },
  {
    text: "AI Assistants",
    type: RouteType.Internal,
    to: "/ai-assistants",
    icon: <WidgetIcon />
  },
  {
    text: "AI Engines",
    type: RouteType.Internal,
    to: "/ai-engines",
    icon: <AssistantIcon />
  },
  {
    text: "AI Engine Group",
    type: RouteType.Internal,
    to: "/aienginegroup",
    icon: <GeTestsIcon />
  },
  {
    text: "AI Prompts",
    type: RouteType.Internal,
    to: "/ai-prompts",
    icon: <CommentIcon />
  },
  {
    text: "Datasets",
    type: RouteType.Internal,
    to: "/datasets",
    icon: <DatasetIcon />
  },
  {
    text: "Client Descriptions",
    type: RouteType.Internal,
    to: "/client-descriptions",
    icon: <GeEditIcon />
  },
  {
    text: "Prompt Execution History",
    type: RouteType.Internal,
    to: "/promptexecutionhistory",
    icon: <GeSettingsGeneral />
  },
  {
    text: "Style Guides",
    type: RouteType.Internal,
    to: "/client-designs",
    icon: <GeDashboardIcon />
  },
  {
    text: "Page Stats",
    type: RouteType.Internal,
    to: "/pagestats",
    icon: <QueryStatsIcon />
  },
  {
    text: "AI Analytics",
    type: RouteType.Internal,
    to: "/ai-analytics",
    icon: <AssessmentIcon />
  },
  {
    text: "Users",
    type: RouteType.Internal,
    to: "/users",
    icon: <GeUsersIcon />
  },
  {
    text: "Logs",
    type: RouteType.Internal,
    to: "/logs",
    icon: <GeLogIcon />
  },
  {
    text: "Help",
    type: RouteType.Action,
    action: onHelpUrl,
    icon: <HelpIcon />
  },
  {
    text: "Hangfire",
    type: RouteType.Action,
    action: onHangfireUrl,
    icon: <HangFireIcon variant="square">H</HangFireIcon>
  }
];

const powerUserRoutes = [
  {
    text: "Chat with AI",
    type: RouteType.Internal,
    to: "/chatbot",
    icon: <SmartToyIcon />
  },
  {
    text: "AI Assistants",
    type: RouteType.Internal,
    to: "/ai-assistants",
    icon: <WidgetIcon />
  },
  {
    text: "AI Prompts",
    type: RouteType.Internal,
    to: "/ai-prompts",
    icon: <CommentIcon />
  },
  {
    text: "Datasets",
    type: RouteType.Internal,
    to: "/datasets",
    icon: <DatasetIcon />
  },
  {
    text: "Client Descriptions",
    type: RouteType.Internal,
    to: "/client-descriptions",
    icon: <GeEditIcon />
  },
  {
    text: "Prompt Execution History",
    type: RouteType.Internal,
    to: "/promptexecutionhistory",
    icon: <GeSettingsGeneral />
  },
  {
    text: "Style Guides",
    type: RouteType.Internal,
    to: "/client-designs",
    icon: <GeDashboardIcon />
  },
  {
    text: "AI Analytics",
    type: RouteType.Internal,
    to: "/ai-analytics",
    icon: <AssessmentIcon />
  },
  {
    text: "Help",
    type: RouteType.Action,
    action: onHelpUrl,
    icon: <HelpIcon />
  },
];

const userRoutes = [
  {
    text: "Chat with AI",
    type: RouteType.Internal,
    to: "/chatbot",
    icon: <SmartToyIcon />
  },
  {
    text: "AI Assistants",
    type: RouteType.Internal,
    to: "/ai-assistants",
    icon: <WidgetIcon />
  },
  {
    text: "AI Prompts",
    type: RouteType.Internal,
    to: "/ai-prompts",
    icon: <CommentIcon />
  },
  {
    text: "Client Descriptions",
    type: RouteType.Internal,
    to: "/client-descriptions",
    icon: <GeEditIcon />
  },
  {
    text: "Prompt Execution History",
    type: RouteType.Internal,
    to: "/promptexecutionhistory",
    icon: <GeSettingsGeneral />
  },
  {
    text: "Style Guides",
    type: RouteType.Internal,
    to: "/client-designs",
    icon: <GeDashboardIcon />
  },
  {
    text: "Help",
    type: RouteType.Action,
    action: onHelpUrl,
    icon: <HelpIcon />
  },
];

const baseSpacing = 30;

const RenderInternal = ({ item, closeDrawer, menuOpen = true, depth = 0 }) => {
  const classes = useStyles();
  const history = useHistory();
  const active = history.location.pathname === item.to;

  return (
    <ListItem
      button
      component={RouterLink}
      onClick={closeDrawer}
      to={item.to}
      className={active ? classes.active : null}
      sx={
        depth !== 0
          ? {
              paddingLeft:
                baseSpacing * depth - (active ? 4 : 0) + "px!important;"
            }
          : {}
      }
    >
      <ListItemIcon className={classes.listItemIcon} title={item.text}>
        {item.icon}
      </ListItemIcon>
      <ListItemText
        primary={menuOpen ? item.text : ""}
        primaryTypographyProps={{ variant: "body2" }}
      />
    </ListItem>
  );
};

const RenderExternal = ({ item, menuOpen = true, depth = 0 }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <ListItem
      button
      component={"a"}
      href={item.to}
      rel="noreferrer"
      target="_blank"
      style={
        depth !== 0
          ? { paddingLeft: baseSpacing * depth + "px!important;" }
          : {}
      }
    >
      <ListItemIcon className={classes.listItemIcon} title={item.text}>
        {item.icon}
      </ListItemIcon>
      <ListItemText
        primary={menuOpen ? item.text : ""}
        primaryTypographyProps={{ variant: "body2" }}
      />
    </ListItem>
  );
};

const RenderAction = ({ item, menuOpen = true, depth = 0 }) => {
  const classes = useStyles();
  const onClick = () => {
    if (item.action !== null) item.action();
  };

  return (
    <ListItem
      button
      onClick={onClick}
      sx={
        depth !== 0
          ? { paddingLeft: baseSpacing * depth + "px!important;" }
          : {}
      }
    >
      <ListItemIcon className={classes.listItemIcon} title={item.text}>
        {item.icon}
      </ListItemIcon>
      <ListItemText
        primary={menuOpen ? item.text : ""}
        primaryTypographyProps={{ variant: "body2" }}
      />
    </ListItem>
  );
};

const RenderMenu = ({ item, closeDrawer, menuOpen = true, depth = 0 }) => {
  const classes = useStyles();
  const history = useHistory();
  const isOpen = (item) => {
    return item.items.some((x) =>
      x.type === RouteType.Menu ? isOpen(x) : history.location.pathname === x.to
    );
  };
  const [open, setOpen] = React.useState(isOpen(item));

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <React.Fragment>
      <ListItem
        button
        onClick={handleClick}
        className={isOpen(item) ? classes.activeMenu : null}
        sx={
          depth !== 0
            ? {
                paddingLeft:
                  baseSpacing * depth - (isOpen(item) ? 2 : 0) + "px!important;"
              }
            : {}
        }
      >
        <ListItemIcon className={classes.listItemIcon} title={item.text}>
          {item.icon}
        </ListItemIcon>
        <ListItemText
          primary={menuOpen ? item.text : ""}
          primaryTypographyProps={{ variant: "body2" }}
        />
        {menuOpen && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item.items.map((subItems, index) =>
            subItems.type === RouteType.Menu ? (
              <RenderMenu
                key={index}
                item={subItems}
                closeDrawer={closeDrawer}
                menuOpen={menuOpen}
                depth={depth + 1}
              />
            ) : subItems.type === RouteType.Internal ? (
              <RenderInternal
                key={index}
                item={subItems}
                closeDrawer={closeDrawer}
                depth={depth + 1}
                menuOpen={menuOpen}
              />
            ) : (
              <RenderExternal key={index} item={subItems} depth={depth + 1} />
            )
          )}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export default function Sidebar({
  userProfile,
  handleDrawerClose = null,
  menuOpen = true
}) {
  const [role, setRole] = useState("");
  const classes = useStyles();
  const closeDrawer = () => {
    if (handleDrawerClose !== null) handleDrawerClose();
  };

  useEffect(() => {
    if (userProfile !== null && userProfile !== undefined) {
      setRole(userProfile.role);
    } else {
      setRole(null);
    }
  }, [userProfile]);

  const RenderRoutes = ({ items }) => (
    <React.Fragment>
      {items.map((item, index) =>
        item.type === RouteType.Menu ? (
          <RenderMenu
            key={index}
            item={item}
            closeDrawer={closeDrawer}
            menuOpen={menuOpen}
          />
        ) : item.type === RouteType.Internal ? (
          <RenderInternal
            key={index}
            item={item}
            closeDrawer={closeDrawer}
            menuOpen={menuOpen}
          />
        ) : item.type === RouteType.External ? (
          <RenderExternal key={index} item={item} menuOpen={menuOpen} />
        ) : (
          <RenderAction key={index} item={item} menuOpen={menuOpen} />
        )
      )}
    </React.Fragment>
  );

  return (
    <List component="nav" className={classes.sidebarContainer}>
      <div className={classes.routesContainer}>
        {
          {
            Admin: <RenderRoutes items={adminRoutes} />,
            PowerUser: <RenderRoutes items={powerUserRoutes} />,
            User: <RenderRoutes items={userRoutes} />,
          }[role]
        }
      </div>
      <Typography variant="caption" className={classes.footerMessage}>
        <WarningIcon className={classes.warningIcon} />
        AI can make mistakes; please always validate the information before sending to the client.
      </Typography>
    </List>
  );
}
